"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AlertDialog, Callout, Flex, Text, VisuallyHidden, } from "@radix-ui/themes";
import { useRef } from "react";
import { useRevokeUserInvite } from "./api/user";
import { AlertDialogContent, DestructiveButton, SecondaryButton, } from "./elements";
export function RevokeInviteDialog({ children, user, ...props }) {
    const revokeInvite = useRevokeUserInvite();
    const cancelButtonRef = useRef(null);
    const onSubmitForm = () => {
        revokeInvite.mutate({ userId: user.id }, {
            onSuccess: () => {
                props.onOpenChange?.(false);
            },
        });
    };
    return (_jsxs(AlertDialog.Root, { ...props, children: [children && _jsx(AlertDialog.Trigger, { children: children }), _jsxs(AlertDialogContent, { maxWidth: "480px", onOpenAutoFocus: () => {
                    requestAnimationFrame(() => {
                        cancelButtonRef.current?.focus();
                    });
                }, children: [_jsx(AlertDialog.Title, { children: "Revoke invite?" }), _jsx(Flex, { mb: "4", direction: "column", gap: "3", children: _jsxs(AlertDialog.Description, { children: ["Are you sure you want to revoke the invite to", " ", _jsx(Text, { weight: "bold", children: user.email }), "? This action is immediate and cannot be undone."] }) }), revokeInvite.error ? (_jsx(Callout.Root, { color: "red", mt: "4", mb: "-2", children: _jsx(Callout.Text, { children: getMutationErrorMessage(revokeInvite.error) }) })) : null, _jsx(Flex, { gap: "3", justify: "end", mt: "5", asChild: true, children: _jsxs("form", { onSubmit: (event) => {
                                event.preventDefault();
                                onSubmitForm();
                            }, children: [_jsx(AlertDialog.Cancel, { children: _jsx(SecondaryButton, { ref: cancelButtonRef, disabled: revokeInvite.isPending, children: "Cancel" }) }), _jsx(DestructiveButton, { type: "submit", loading: revokeInvite.isPending, children: "Revoke" })] }) })] }), _jsx(VisuallyHidden, { asChild: true, children: _jsx("section", { "aria-live": "polite", children: getMutationErrorMessage(revokeInvite.error) }) })] }));
}
function getMutationErrorMessage(error) {
    if (!error) {
        return null;
    }
    // TODO Handle server errors
    return "There was an error revoking the invite. Please try again.";
}
//# sourceMappingURL=revoke-invite-dialog.js.map